import { Globals } from '@bwoty-web/ui-kit';
import { hydrateRoot } from 'react-dom';
import PackagePlusOtherOptionsView from '../shared/views/packagePlus/packagePlusOtherOptionsView';

const initialStateGeoPackagePlusOtherOptions =
  window.__INITIAL_STATE_GEO_PACKAGE_PLUS_OTHER_OPTIONS__;
delete window.__INITIAL_STATE_GEO_PACKAGE_PLUS_OTHER_OPTIONS__;
const geoPackagePlusOtherOptionsRoot = document.getElementById(
  'geo-package-plus-other_options-view',
);

if (geoPackagePlusOtherOptionsRoot) {
  const {
    attributes,
    initialIsMobile,
    legacyMode,
    mainProductGeoType,
    otherOptions,
    siteId,
  } = initialStateGeoPackagePlusOtherOptions;
  hydrateRoot(
    geoPackagePlusOtherOptionsRoot,
    <Globals siteId={siteId} legacyMode={legacyMode}>
      <PackagePlusOtherOptionsView
        labels={attributes}
        mainProductGeoType={mainProductGeoType}
        otherOptions={otherOptions}
        initialIsMobile={initialIsMobile}
      />
    </Globals>,
  );
}
